import shouldFilterMiscError from './blockedErrors/miscErrors';
import shouldFilterThirdPartyLibraryError from './blockedErrors/thirdPartyLibraryErrors';

function shouldFilterError(event) {
  const error = event.exception?.values?.[0];
  // We will require an error to perform any useful filtering. Check it's available first
  // to avoid needing to repeatedly check in each individual handler:
  if (!error) {
    return false;
  }
  return (
    shouldFilterThirdPartyLibraryError(error) || shouldFilterMiscError(error)
  );
}

export function sentryEventProcessor(event) {
  let shouldFilter = false;
  // Ensure exists as an Object:
  const extraData = event.extra ? { ...event.extra } : {};
  extraData.xmProcessed = true;

  if (event?.level === 'error') {
    extraData.xmIsError = true;
    try {
      shouldFilter = shouldFilterError(event);
      extraData.xmShouldFilter = !!shouldFilter;
    } catch (e) {
      try {
        extraData.xmFilterError = JSON.stringify(e.stack);
      } catch (innerError) {
        extraData.xmFailedToStringify = true;
        // eslint-disable-next-line no-console
        console.error('Failed to add filter error to Sentry event', innerError);
      }
    }
  }

  // TEMPORARY: Examine why a few errors are failing to get filtered out:
  try {
    extraData.xmEventExceptionData = JSON.stringify(event.exception);
  } catch (e) {
    try {
      extraData.xmEventExceptionData = `__xm-serialize-error__ ${e.message}`;
    } catch (innerError) {
      extraData.xmEventExceptionData = '__xm-serialize-error-error__';
    }
  }

  // eslint-disable-next-line no-param-reassign
  event.extra = extraData;
  return shouldFilter ? null : event;
}

// Allow binding in ondemand code if needed:
window.xmSentryEventProcessor = sentryEventProcessor;

export function configureSentryErrorFilters() {
  window.Sentry?.addGlobalEventProcessor(sentryEventProcessor);
}
